import { Injectable, Injector } from '@angular/core';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { Overlay, OverlayRef, OverlayConfig } from '@angular/cdk/overlay';
import { CAMERA_REF } from './camera-ref_token';
import { CAMERA_CONTEXTO, CameraConviteContexto } from './camera-contexto';
import { CameraComponent } from './camera.component';
import { CameraConviteComponent } from './camera-convite.component';
import { AbCamera } from 'app/abstract/camera/camera.abstract';

@Injectable({ providedIn: 'root' })
export class CameraService extends AbCamera {

  private overlay: OverlayRef;

  constructor(
    private injector: Injector,
    private overlayService: Overlay
  ) {
    super()
  }

  public open(): Promise<string> {
    if (!this.overlay) {
      this.overlay = this.createOverlay();
    }
    return new Promise<string>((resolve, reject) => {
      // create injector

      const injector = Injector.create({
        parent: this.injector,
        providers: [
          {
            provide: CAMERA_REF, useValue: {
              close: returnValue => {
                this.overlay.detach();
                resolve(returnValue);
              },
              reject: reason => {
                this.overlay.detach();
                reject(reason);
              }
            }
          }
        ]
      })
      // create portal
      const portal = new ComponentPortal(CameraComponent, null, injector);
      // attach portal to overlay
      this.overlay.attach(portal);
    });
  }

  public openConvite(contexto?: CameraConviteContexto): Promise<string> {
    if (!this.overlay) {
      this.overlay = this.createOverlay();
    }
    return new Promise<string>((resolve, reject) => {
      // create injector

      const injector = Injector.create({
        parent: this.injector,
        providers: [
          {
            provide: CAMERA_REF, useValue: {
              close: returnValue => {
                this.overlay.detach();
                resolve(returnValue);
              },
              reject: reason => {
                this.overlay.detach();
                reject(reason);
              }
            }
          },
          { provide: CAMERA_CONTEXTO, useValue: contexto ?? {} }
        ]
      })
      // create portal
      const portal = new ComponentPortal(CameraConviteComponent, null, injector);
      // attach portal to overlay
      this.overlay.attach(portal);
    });
  }

  public createOverlay(): OverlayRef {
    const config = new OverlayConfig();
    config.positionStrategy = this.overlayService.position()
      .global();
    config.panelClass = 'full-panel';
    return this.overlayService.create(config);
  }

}
